var ActionType;
(function(ActionType) {
    ActionType["Action"] = "Action";
    ActionType["Add"] = 'AddAction';
    ActionType["Delete"] = 'DeleteAction';
    ActionType["Reserve"] = 'ReserveAction';
    ActionType["Subscribe"] = 'SubscribeAction';
    ActionType["Search"] = 'SearchAction';
    ActionType["UnRegister"] = 'UnRegisterAction';
})(ActionType || (ActionType = {}));

export { ActionType };
//# sourceMappingURL=types.js.map
